<template>
    <div class="flex justify-center h-screen flex items-center">
        <div class="flex">
            <LoaderComponent />
            <span class="my-auto ml-5 text-3xl text-dark-carrot font-bold" :class="animationState">
                Carregando...
            </span>
        </div>
    </div>
</template>
<script setup>
    import LoaderComponent from '@/components/Utils/LoaderComponent.vue';
    import requestHandler from '@/composables/requestHandler';
    import { sleep } from '@/composables/sleep';
    import authUserService from '@/services/BudgetService';
    import { useSessionMessageStore } from '@/stores/sessionMessage';
    import { onMounted, ref } from 'vue';

    onMounted(() => {
        loadAnimation();
        redirectAsExpected()
    });

    async function redirectAsExpected(){
        const response = await authUserService.attemptLogin();
        if(!response.success()){
            useSessionMessageStore.errorMessage('not authenticated');
            await requestHandler.redirect('/login');
            return;
        }
    }

    let killAnimation = ref(false);
    let animationState = ref(null);
    async function loadAnimation(){
        while(!killAnimation.value){
            await sleep(2000);
            animationState.value = [null,'fade-in'].includes(animationState.value) ? 'fade-out' : 'fade-in';
        }
    }
</script>
<style>
    .fade-in{
        opacity: 1;
        transition: 0.2s ease-in;
    }
    .fade-out{
        opacity: 0;
        transition: 0.4s ease-in;
    }
</style>